import SHSkeleton from "@components/design-systems/sh-skeleton";
import { SHStack } from "@components/design-systems";

export const AnalysisNameSkeleton = () => {
  return (
    <SHStack
      direction="column"
      justifyContent="flex-start"
      width={"100%"}
      gap={1}
    >
      <SHSkeleton height={20} width={"60%"} />
      <SHSkeleton height={20} width={"35%"} />
    </SHStack>
  );
};
